import axios from 'axios';

const axiosConfig = () => {
  axios.defaults.headers.common['X_REQUESTED_WITH'] = 'XMLHttpRequest';
  axios.defaults.withCredentials = true;
  return axios;
}

export default axiosConfig();



// WEBPACK FOOTER //
// ./app/javascript/shared/axiosConfig.js